import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-posted-by-me',
  templateUrl: './ticket-posted-by-me.component.html',
  styleUrls: ['./ticket-posted-by-me.component.css']
})
export class TicketPostedByMeComponent implements OnInit {
  i: any;
  deleteId: any;
  ticketcontroller:any = [];
  TicketTask: any = [];
  users: any = [];
  TicketTaskdata: any = [];
  TicketData: any = [];
  ticketImages: any = [];
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  userIdList = [];
  taskMasters:any = []
  status= ""
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  Taskform:any | FormGroup
  modelSubtitle = false
  IDs:any = []
  data:any = []
  fileType:any;
  file = '';
  images:any= [];
  videos:any= [];
  audios:any= [];
  description = "";
  typeId = "";
  heading = "";
  details = "";
  source = "";
  customerID = "";
  customerType = ""
  searchFilter = ''
  newTicketCount= 0
  ticketId = 0
  ticketDesc = ""
  taskId = ""
  note = ""
  ticketStatus = ""
  usersList: any= []
  assignInput = ""
  addClassType = ""
  TaskNameAndDescription: any = []
  cid:any
  addTaskButton = true
  endDate:any;
  startDate:any;

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  toDayDate: any = ""

  largeImage: any = ""

  
  ngOnInit(): void {
    this.endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
    this.startDate = new Date()
    this.startDate.setDate(this.startDate.getDate()-90);
    this.startDate = formatDate(this.startDate, 'yyyy-MM-dd', 'en-US')
    this.toDayDate = new Date().getTime()

    this.cid = sessionStorage.getItem('cid')
    this.getUsers();
    this.getAllTaskNameAndDescription()
    this.generic_service.gettypeids().subscribe((res: any) => {
      console.log(res)
      this.IDs = res.response
    })
    
    this.getAllTicketPostedByMe(this.pageNumber,this.recordsPerPage)

    this.form = this.fb.group({
      description: [''],
      typeId: [''],
      heading:[''],
      details:[''],
      customerID:[''],
      customerType:['']
    });

    this.Taskform = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });

  }


  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllTicketPostedByMe(this.pageNumber-1,this.recordsPerPage)
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  addcontroller(){

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "typeId":String(this.form.get('typeId').value),
      "ticketSubTypeId": 0,
      "parentTicketId": 0,
      "priorityId": 0,
      "ticketStatus": [
        {
          "note": "",
          "ticketStatus": "OPEN",
          "updatedDate": 0
        }
      ],
      "heading": String(this.form.get('heading').value),
      "details":  String(this.form.get('details').value),
      "resolution": "",
      "source":  "Admin",
      "raisedBy": "",
      "remarks": "",
      "assignedTo": "",
      "startTime": 0,
      "endTime": 0,
      "customerID":  String(this.form.get('customerID').value),
      "customerName": "",
      "customerNotes": "",
      "technicianNotes": "",
      "startNotes": "",
      "endNotes": "",
      "pendingNotes": "",
      "customerType":  String(this.form.get('customerType').value),
      "latestTicketStatus": "OPEN",
      "assignedBy": "",
      "latitude": "",
      "startLatitude": "",
      "startLongitude": "",
      "endLatitude": "",
      "endLongitude": "",
      "agentId": 0,
      "audio": [],
      "video": [],
      "image": [],
      "tagUserIds": [],
      "assignedOn": 0,
      "longitude": "",
      "ticketNo": 0,
      "cid": this.cid
    }

 
    console.log(body)
    this.generic_service.addcontroller(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTicketPostedByMe(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
        this.form.clear()
      },(err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }

  Ticketid(id:any,details:any,name:any){
    this.ticketId = id
    this.Taskform.get('description').setValue(details);
    this.Taskform.get('name').setValue(name);
    console.log(this.ticketId)
  }

  addTicketTask(){
    this.addTaskButton = false
    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }

    let body = {
      "ticketId": this.ticketId,
      "taskList": [
        {
          "version": 0,
          "isActive": true,
          "description":String(this.Taskform.get('description').value),
          "taskRegType": "",
          "taskRegId": "",
          "taskSINumber": 0,
          "taskListingNumber": 0,
          "assignedTo": String(this.Taskform.get('assignedTo').value),
          "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
          "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
          "taskActStartDate": 0,
          "taskActEndDate": 0,
          "taskExpDuration": 0,
          "taskActDuration": 0,
          "status": [
            {
              "note": "",
              "taskStatus": "NEW",
              "updatedDate": 0
            }
          ],
          "completedPercentage": 0,
          "notes": "",
          "audio": this.audios,
          "video": this.videos,
          "image": this.images,
          "tagUserIds": tagUserIds,
          "name": String(this.Taskform.get('name').value),
          "cid": this.cid
        }
      ]
    }
    console.log(body)
    this.generic_service.addTicketTask(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTicketTask()
        this.toastr.success(response.message);
        this.cancelModel()
        this.clearForm()
        this.addTaskButton = true
      },(err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);
        this.addTaskButton = true
      }
    )


  }

  getAllTicketTask(){
    this.generic_service.getAllTicketTask().subscribe(
      (response:any)=>{
        this. TicketTask= response.taskList;
        console.log(response)
      }
    )
  }

  getTicketTaskByID(id:any){
    this.selectLargeImage("")

    console.log(id)
    this.ticketId = id
    this.getSingleTicket(id)
    this.getAllTaskMasters()
    // this.TicketData = []
    this.generic_service.getTicketTaskByID(id).subscribe(
      (res:any)=>{
        // this.TicketData.push(res.response.ticket);
        this.TicketTaskdata = res.response.taskList;
        console.log(res);
        let arr:any = [];
        arr.push(Number(sessionStorage.getItem('userId')))
        let arr1:any = [];
        // arr = res.response.taskList.tagUserIds;
        for (let i=0; i<res.response.taskList.length; i++){
          if(res.response.taskList[i].assignedTo != null && res.response.taskList[i].assignedTo != 0){
            arr1.push(res.response.taskList[i].assignedTo)
          }
          if(res.response.taskList[i].tagUsers.length != 0){
            for(let j=0; j<res.response.taskList[i].tagUsers.length; j++){
              arr.push(res.response.taskList[i].tagUsers[j].userid)
            }
          }
        }
        let arr3 = arr.concat(arr1)
        this.userIdList = arr3
        // arr.push(res.response.assignedTo)
        this.userIdList = this.userIdList.filter((item,index) => this.userIdList.indexOf(item) === index);
        console.log(this.userIdList)

      },
      (err:any)=>{
        console.log(err)
        this.TicketTaskdata = []
      }
    )
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.users = res.response;
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response
        console.log(res);
      }
    )
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButton67")?.click()
  }

  getAllTicketPostedByMe(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getAllTicketPostedByMe(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList;
        console.log(response)
        this.isLoading = false

      },
      (error: any)=>{
        this.isLoading = false
      }
    )
  }

  editskill(){
  
    this.data[this.i].description=this.description
    this.data[this.i].typeId=this.typeId
    this.data[this.i].heading=this.heading
    this.data[this.i].details=this.details
    this.data[this.i].source=this.source
    this.data[this.i].customerID=this.customerID
    this.data[this.i].customerType=this.customerType
    this.close()
  }
  open() {
    this.modelSubtitle = true;
  }
  close() {
    this.modelSubtitle = false;
    this.description = ""
    this.typeId = ""
    this.heading = ""
    this.details = " "
    this.source = ""
    this.customerID = ""
    this.customerType =""     
  }
  
  edit(i:any){
    this.open();
    this.description = this.data[i].description;
    this.typeId = this.data[i].typeId ;
    this.heading = this.data[i].heading ;
    this.details = this.data[i].details ;
    this.source = this.data[i].source ;
    this.customerID = this.data[i].customerID ;
    this.customerType = this.data[i].customerType ;
  }

  delTicketController(){
    this.generic_service.delTicketcontroller(this.deleteId).subscribe(
      (res:any)=>{
        console.log(res);
        this.toastr.success(res.message);
        this.getAllTicketPostedByMe(this.pageNumber-1,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  getSingleTicket(id:any){
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res:any)=>{
        this.TicketData = [];
        this.ticketImages = res.response.ticket.image
        this.TicketData.push(res.response.ticket);
        console.log(this.ticketImages)
      }
    )
  }

  onSelectFile(event:any){
    if(event.target.files){
      console.log(event.target.files[0].type)
      console.log(event.target.files[0])
      if(event.target.files[0].type == "image/jpeg" || event.target.files[0].type == "image/png" || event.target.files[0].type == "image/png"){
        console.log('image')
        this.fileType = 'image'
      }else if(event.target.files[0].type == "video/mp4"){
        console.log('video')
        this.fileType = 'video'
      }else if(event.target.files[0].type == "audio/mpeg"){
        console.log('audio')
        this.fileType = 'audio'
      }
      var reader = new FileReader;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload=(e:any)=>{
        this.file=e.target.result;
        if(this.fileType == 'image'){
          this.images.push(this.file)
        }
        if(this.fileType == 'video'){
          this.videos.push(this.file)
        }
        if(this.fileType == 'audio'){
          let file = URL.createObjectURL(event.target.files[0])
          this.audios.push(file)
        }
      }
    }
  }

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn(){
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn(){
    document.getElementById("add-audio-btn")?.click()
  }
   
  addc(i: any){
    console.log(i)
    let list = document.getElementById(i)
    if(list?.classList.contains('dropdown-data-show')){
      list.classList.remove('dropdown-data-show')
    }else{
      list?.classList.add('dropdown-data-show')
    }
  }

  activeStatus(id: string){

  }

  insertConversation(){
    let body =  {
      "version": 0,
      "isActive": true,
      "description": "string",
      "id": 0,
      "conversationType": "TICKET",
      "ticketTaskId": Number(this.ticketId),
      "userIdList": this.userIdList,
      "remarks": "string",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.toastr.success(response.message)
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  remoates(){
    var array = this.userIdList;
    return array.filter((item,index) => array.indexOf(item) === index);
  }
  
  clearForm(){
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  statusDropdown(){
    let list = document.getElementById('dropS')
    if(list?.classList.contains('status-dropdown-show')){
      list.classList.remove('status-dropdown-show');
    }else{
      list?.classList.add('status-dropdown-show')
    }
  }

  updateTicketStatus(ticketId:any){
    let body = {
      "note": String(this.note),
      "ticketStatus": String(this.ticketStatus),
      "updatedDate": 0
    }
    this.generic_service.updateTicketStatus(ticketId,body).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getSingleTicket(ticketId)
        this.statusDropdown()
        this.getAllTicketPostedByMe(this.pageNumber-1,this.recordsPerPage)
        console.log(response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  AssignToUser(ticketId:any, userId: any,ticketStatus:any,name:string){
    let note = "";
    if(ticketStatus == "REASSIGNED"){
      note = "Ticket REASSIGNED to " + name;
    }
    if(ticketStatus == "ASSIGNED"){
      note = "Ticket ASSIGNED to " + name;
    }
    let body = {
      "ticketId": Number(ticketId),
      "userId": Number(userId),
      "ticketStatusDTO": {
        "note": String(note),
        "ticketStatus": "OPEN",
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.ticketAssignToUser(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.getSingleTicket(ticketId)
        this.addClass('assignedTo')
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  addClass(value:any){
    console.log(value)
    if(this.addClassType == ''){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      if(this.addClassType == value){
        let list = document.getElementById('assign-and-tag-data')
        if(list?.classList.contains('assign-show')){
          list.classList.remove('assign-show')
          this.addClassType = ''
        }else{
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      }else{
        this.addClassType = value
      }
    }
  }

  getAllTaskMasters(){
    this.generic_service.getAllTaskMaster().subscribe(
      (response:any)=>{
        console.log(response)
        this.taskMasters = response.response
      }
    )
  }

  getAllTaskNameAndDescription(){
    this.generic_service.getAllTaskNameAndDescription().subscribe(
      (response:any)=>{
        console.log(response)
        this.TaskNameAndDescription = response.response
      }
    )
  }

  addTaskMaster(j:any){
    let tasks = this.taskMasters[j].taskGroup;
    console.log(tasks)
    for(let i = 0; i < tasks.length; i++) {
      this.addMasterTicketTask(tasks[i].name,tasks[i].description)
    }

    setTimeout(() => this.reload(), 2000);

  }

  reload(){
    this.getTicketTaskByID(this.ticketId)
    document.getElementById("closeModalButton5")?.click()
  }


  addMasterTicketTask(name:any,description: any){

    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }

    let body = {
      "ticketId": this.ticketId,
      "taskList": [
        {
          "version": 0,
          "isActive": true,
          "description":String(description),
          "taskRegType": "",
          "taskRegId": "",
          "taskSINumber": 0,
          "taskListingNumber": 0,
          "assignedTo": String(this.Taskform.get('assignedTo').value),
          "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
          "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
          "taskActStartDate": 0,
          "taskActEndDate": 0,
          "taskExpDuration": 0,
          "taskActDuration": 0,
          "status": [
            {
              "note": "",
              "taskStatus": "NEW",
              "updatedDate": 0
            }
          ],
          "completedPercentage": 0,
          "notes": "",
          "audio": this.audios,
          "video": this.videos,
          "image": this.images,
          "tagUserIds": tagUserIds,
          "cid": this.cid,
          "name": String(name),
        }
      ]
    }
    console.log(body)
    this.generic_service.addTicketTask(body).subscribe(
      (response:any)=>{
        console.log(response)
        // this.getAllTicketTask()
        // this.toastr.success(response.message);
        // this.cancelModel()
        // this.clearForm()
      },(err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }

  ticketStatusDropdown(){
    console.log(this.ticketStatus)
    if(this.ticketStatus == "COMPLETED"){
      this.note = "Ticket Complteed by" + " " + sessionStorage.getItem('userName')
    }
    if(this.ticketStatus == "CLOSED"){
      this.note = "Ticket Closed by"  + " " + sessionStorage.getItem('userName')
    }

  }

  autoFill(taskName: any,taskDescription:any){
    this.Taskform.get('name').setValue(taskName);
    this.Taskform.get('description').setValue(taskDescription);
    document.getElementById("closeModalButton67")?.click()

  }


  ticketByStatus(){
    if(this.status != "ALL"){
      // this.generic_service.ticketFilterByStatus(this.status).subscribe(
      //   (response:any)=>{
      //     console.log(response)
      //     this.data = response.response
      //   },
      //   (error:any)=>{
      //     console.log(error)
      //   }
      // )
    }else{
      this.getAllTicketPostedByMe(this.pageNumber-1,this.recordsPerPage)
    }
  }

  taskPopUpClose(){
    document.getElementById("closeModalButton3")?.click()
  }


  addTicketImageBtn(){
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }
  
  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.ticketImages.push(event.response)
      this.updateTicketPicture()
    });
  }

  updateTicketPicture(){
    let body = {
      "ticketId": this.TicketData[0].ticketId,
      "cid": Number(this.cid),
      "images": this.ticketImages
    }

    this.generic_service.updateTicketPicture(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success("Successfully Updated");
        this.getSingleTicket(this.ticketId)

        this.images = []
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  selectLargeImage(largeImage: any){
    this.largeImage = largeImage
  }

  updateImg(img: any){

    let images: any = []

    for(let list of this.ticketImages){
      if(list != img){
        images.push(list)
      }
    }

    let body = {
      "ticketId": this.ticketId,
      "cid": this.TicketData[0].cid,
      "images": images
    }

    console.log(body)

    this.generic_service.updateTicketPicture(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success("Successfully Updated");
        this.getSingleTicket(this.ticketId)

        this.images = []
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

}
